<template>
    <div class="role-view">
        <div class="bg-white mt-3 p-3 activity-type-create col-12">
            <div class="d-flex title-bar-block mb-2">
                <div class="icon-block me-4">
                    <button v-b-tooltip.hover :title="$backLabel()" @click="cancel()">
                        <i class="fa fa-chevron-left text-white" aria-hidden="true"></i>
                    </button>
                </div>
                <div class="text">
                    <span class="me-2"> {{ $translate('view_activity_type_role') }}</span>
                </div>
            </div>
            <b-form class="form-sample" @submit.prevent="update()">
                <b-row>
                    <b-col cols="12">
                        <label for="input-name" class="mb-3">
                            <strong>{{ $nameLabel() }}<span class="red">*</span></strong>
                        </label>
                        <b-form-input type="text" id="input-name" v-model="model.name" required
                            :placeholder="$translate('enter_name')" trim></b-form-input>
                    </b-col>
                    <b-col cols="12" class="my-3">
                        <label class="form-control-label mb-3"><strong>{{ $translate('permissions') }}</strong></label>
                        <activity-permission-groups v-model="model.activity_permissions"></activity-permission-groups>
                    </b-col>
                    <b-col cols="12" class="mt-3 d-flex gap-2 justify-content-center">
                        <b-button @click="update()" variant="info" size="fw" :disabled="updating ? true : false">{{
                            updating ? $translate('saving_changes') + '...' : $translate('save_changes')
                        }}</b-button>
                        <b-button @click="deleteRole()" size="fw" variant="delete-button">
                            <!-- class="btn btn-" -->
                            {{ $translate('delete_role') }}
                        </b-button>
                        <b-button :disabled="updating" variant="info" size="fw" @click="cancel()">
                            {{ $deleteLabel() }}
                        </b-button>
                    </b-col>
                </b-row>
            </b-form>
        </div>
    </div>
</template>
<script>
//import Multiselect from 'vue-multiselect'
import ActivityPermissionGroups from '@/components/ActivityPermissionGroups'
import popupMixins from '@/mixins/popupMixins'
import activityPermissionMixins from '@/mixins/activityPermissionMixins'
import utilityMixins from '@/mixins/utilityMixins'

export default {
    name: 'activity-type-roles-view',
    mixins: [popupMixins, activityPermissionMixins, utilityMixins],
    components: { ActivityPermissionGroups },
    data() {
        return {
            componentName: 'Role',
            model: {
                id: 0,
                name: '',
                activity_permissions: [],
            },
            updating: false,
        }
    },
    computed: {
        user_permissions() {
            return this.$store.state.user_permissions
        },
        role() {
            return this.$store.state.activityTypeRoles.item || {}
        },
    },
    watch: {
        role: function (val) {
            const model = { ...val }
            model.activity_permissions = model.activity_permissions.map(x => x.activity_permission)
            this.model = model
        },
    },
    methods: {
        cancel() {
            this.$router.push('/ams/roles')
        },
        async update() {

            this.updating = true
            const valid = await this.$validator.validate()
            if (!valid) {
                throw new Error('Not Valid')
            }
            console.log('update', this.model)
            this.$store.dispatch('activityTypeRoles/update', this.model).then(() => {
                this.genericToast(
                    this.componentName,
                    'Updated',
                    'success',
                    'Role has been updated successfully'
                )
            }).catch(error => {
                this.genericToast(
                    this.componentName,
                    'Duplicate',
                    'danger',
                    `${error.message}`
                )
            })
                .finally(() => {
                    this.updating = false
                })


            // this.doToast('Role Updated', 'success')
        },

        deleteRole() {
            // Initializing key variables
            const model = { ...this.model }
            const routes = {
                baseRoute: '/roles',
                deleteRoute: 'roles/delete',
            }
            const notificationFields = {
                type: 'Role',
                errorMsg: 'Unable to delete role!',
            }

            this.deleteItem(notificationFields, model, routes)
        },
    },
    mounted() {
        this.$store.dispatch('permissions/allActivityTypePermission')
        this.$store.dispatch('activityTypeRoles/fetchById', this.$route.params.id)
    },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
